import SearchResults from '@features/search/SearchForm/SearchResults';
import { useDebounce } from '@store/hooks/useDebounce';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  apiUrl: string;
  formUrl: string;
}

export default function SearchForm({ apiUrl, formUrl }: IProps) {
  const { t } = useTranslation();

  const [searchTerm, setSearchTerm] = useState<string | undefined>();
  const debounceSearchTerm = useDebounce(searchTerm, 300);

  const searchLink = useMemo(() => {
    const url = new URL(formUrl, window.location.origin);
    url.searchParams.set('searchTerm', debounceSearchTerm!);
    return url.toString();
  }, [debounceSearchTerm, formUrl]);

  return (
    <form action={formUrl} className="form relative" method="get">
      <div className="flex">
        <div className="flex">
          <button
            aria-disabled="true"
            aria-label={t('ToSearch')}
            className="-mr-px px-5 bg-primary text-white rounded-l-md hover:bg-primary-dark">
            <i className="fa-solid fa-magnifying-glass"></i>
          </button>
          <div className="input">
            <input
              aria-disabled="true"
              autoComplete="off"
              className="input w-72 !rounded-l-none"
              name="searchTerm"
              placeholder={t('WhatAreYouLookingFor')}
              required
              type="search"
              onChange={event => setSearchTerm(event.currentTarget.value)}
            />
          </div>
        </div>
      </div>

      {debounceSearchTerm && debounceSearchTerm.length >= 3 && (
        <SearchResults apiUrl={apiUrl} searchTerm={debounceSearchTerm} searchLink={searchLink} />
      )}
    </form>
  );
}
